import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { AlertController, IonRouterOutlet, ModalController, NavParams, Platform, PopoverController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FcmService } from '@shared/services/fcm.service';
import { PurchaseService } from 'src/app/services/purchase.service';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { ActivatedRoute } from '@angular/router';
import { AvocadoPromotionPage } from '../avocado-promotion/avocado-promotion.page';
import { EventService } from '@shared/services/event.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { InAppBrowser } from '@capgo/inappbrowser';
import { Capacitor } from '@capacitor/core';
import { el } from 'intl-tel-input/i18n';
@Component({
  selector: 'app-store-v2',
  templateUrl: './store-v2.page.html',
  styleUrls: ['./store-v2.page.scss'],
  providers: [UtilService, UserService, FcmService, NavParams, IonRouterOutlet]
})
export class StoreV2Page implements OnInit {
  @Input() from?: string;
  @Input() me?: any;
  private firebasePlugin: any;
  public slideOpts = {
    initialSlide: 1,
    speed: 400,
  };

  protected coinsOwned: number = 0;

  //-------| Premium |-------- => default
  protected premiumExpireDate: Date|any;

  protected premiumMonthlyCoins: number = 3;

  protected premiumPrice: number = 1.49;
  protected premiumPriceMonth: number = 0.80;
  //-------| // |---------
  @ViewChild('swiper') swiperRef: ElementRef | undefined;
  //=======| // |=========

  public userData: any;
  protected selection = ["unselected", "unselected", "unselected", "unselected"];
  public coinsDigits = { digits: 0 };
  protected showingAdvantage: boolean = false;
  public isNative: boolean = true;
  public type: string = '';
  public showContinueWithoutJoining = false
  public isTestAbForAndroid: boolean = false;

  downloadApp() {
    let url = environment.adjustDownloadLink;
    InAppBrowser.open({ url: url });
  }
  protected greyPremiumButton: boolean = true;
  protected greyCoinsButton: boolean = false;
  public backButton: Subscription|any;
  constructor(public platform: Platform,
    public navParams: NavParams,
    private fcm: FcmService,
    private route: ActivatedRoute,
    public userService: UserService,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    public modalCtrl: ModalController,
    public eventService: EventService,
    private util: UtilService,
    public purchaseServiceProvider: PurchaseService,
    public popoverCtrl: PopoverController) {

      this.util.initTranslate();
    this.isNative = this.util.isNative();
    const from = this.navParams.get('from');
  }

  ngOnInit() {
    const from = this.from || this.navParams.get('from');
    
    if (from) {
      let initialSlide = 1; // default
      if (from === 'chat') {
        initialSlide = 5;
      } else if (from === 'teleportation') {
        initialSlide = 4;
      } else if (from === 'joinClub') {
        initialSlide = 6;
      } else if (from === 'noAds') {
        initialSlide = 2;
      }
      this.slideOpts.initialSlide = initialSlide;
    }
  }


  public async fetchRemoteConfig() {

    // await this.firebasePlugin.fetch(async function (result:any) {

    //   //alert('Result Fech: ' + JSON.stringify(result));




    // }, function () {
    //   // error callback
    // });


  }

  private dismissedPromotion: boolean = false;
  async ionViewDidEnter() {
    setTimeout( () => {
      try {
        let from = this.from || this.navParams.get('from');
        if (!from && this.navParams.data) {
          from = this.navParams.data['from'];
        }
        if (!from && this.navParams.data && typeof this.navParams.data === 'object') {
          from = (this.navParams.data as any).from;
        }
        
        if (from) {
          let targetSlide = 1; // default
          if (from === 'chat') {
            targetSlide = 5;
          } else if (from === 'teleportation') {
            targetSlide = 4;
          } else if (from === 'joinClub') {
            targetSlide = 6;
          } else if (from === 'noAds') {
            targetSlide = 2;
          }
          
          if (this.swiperRef?.nativeElement?.swiper) {
            const currentSlide = this.swiperRef.nativeElement.swiper.activeIndex;
            if (currentSlide !== targetSlide) {
              this.swiperRef.nativeElement.swiper.slideTo(targetSlide);
            }
          }
        } else {
          console.log('ionViewDidEnter - No "from" parameter found');
        }
      } catch {}
    }, 1);

  }

  ionViewWillLeave() {
    if(this.backButton){
      this.backButton.unsubscribe();
    }
  }
  ionViewWillEnter() {
    if(this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        this.dismiss();
      }); 
    }

    this.util.initTranslate();
    this.isNative = this.util.isNative();
    const type = this.navParams.get('type');
    this.type = type !== null ? type : '';

    const showContinueWithoutJoining = this.navParams.get('showContinueWithoutJoining');
    this.showContinueWithoutJoining = showContinueWithoutJoining !== null ? true : false;

    let from = this.from || this.navParams.get('from');
    if (!from && this.navParams.data) {
      from = this.navParams.data['from'];
    }
    if (from) {
      let initialSlide = 1; // default
      if (from === 'chat') {
        initialSlide = 5;
      } else if (from === 'teleportation') {
        initialSlide = 4;
      } else if (from === 'joinClub') {
        initialSlide = 6;
      } else if (from === 'noAds') {
        initialSlide = 2;
      }
      this.slideOpts.initialSlide = initialSlide;
    }    


    this.platform.ready().then(async () => {
      this.selection[1] = "selected";
      // this.firebasePlugin = (<any>window).FirebasePlugin;
      // try {
      //   this.isTestAbForAndroid = true;

      //   if(this.isTestAbForAndroid) {
      //     this.selection[1] = "selected";
      //   }else{
      //     this.selection[2] = "selected";
      //   }
        
      // } catch (error) {
      //   console.error(error);
      //   this.isTestAbForAndroid = false;
      // }
      this.isNative = this.util.isNative();
    });    

    Preferences.get({key:'USER_DATA'}).then((val:any) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (val === null) {
        // this.navCtrl.push(LoginPage);
        return;
      } else if (val.needsEmailValidation) {
        // this.navCtrl.push(EmailValidationPage);

        //let modal = this.modalCtrl.create(EmailValidationPage, {showBackdrop:true});
        //modal.present();
        return;
      }
      this.userData = val;
      Preferences.get({key:'LOCAL_PROMOTION'}).then((val:any) => {
        val = val.value ? JSON.parse(val.value) : null;
        if (val != null) {
          let localPromotion = val;
          if (localPromotion != null && !this.dismissedPromotion) {
            let promotion = localPromotion;
            if (this.purchaseServiceProvider.isPremium(this.userData)) {
              return;
            }
            if (promotion.promoClientEndsCalculated != null) {
              let nowNumber: number = (new Date()).getTime();
              let distance: number = promotion.promoClientEndsCalculated - nowNumber;

              if (distance > 1) {
                this.openPromotion();
              } else {
                Preferences.remove({key:"LOCAL_PROMOTION"}).then((val) => {
                  console.log('LOCAL_PROMOTION removed from DB');
                });
              }

            } else {
              // not started yet.
              this.openPromotion();
            }
          }
        }

      });

      if (this.userData?.coins !== null) {
        this.coinsOwned = this.userData?.coins;
        let coinsStr = '' + this.userData?.coins;
        this.coinsDigits.digits = coinsStr.length;
      }
      this.purchaseServiceProvider.configurePurchasing();
    });

    setTimeout(() => {
      if (!this.isSomePriceLoaded()) {
        this.showAlertCouldNotLoadVegglyMarket();
      }
    }, 5000);

  }
  isSomePriceLoaded() {
    if (this.isPriceLoaded(1, 'coin') 
      || this.isPriceLoaded(10, 'coin')
      || this.isPriceLoaded(50, 'coin')
      || this.isPriceLoaded(100, 'coin')
      || this.isPriceLoaded(1, 'premium')
      || this.isPriceLoaded(3, 'premium')
      || this.isPriceLoaded(6, 'premium')
      || this.isPriceLoaded(12, 'premium')
      || this.isPriceLoaded(1, 'club')
      || this.isPriceLoaded(3, 'club')
      || this.isPriceLoaded(6, 'club')
      || this.isPriceLoaded(12, 'club')) {
        return true;
      }
      return false;
  }

  async showAlertCouldNotLoadVegglyMarket() {
    let alert = this.alertCtrl.create({
      subHeader: this.translate.instant('couldNotLoadVegglyMarket'),
      buttons: [
        {
          text: 'OK',
          handler: () => {
            //this.loader.dismiss();
          }
        }
      ]
    });
    (await alert).present();
  }

  async openPromotion() {
    let modal = this.modalCtrl.create({ component: AvocadoPromotionPage, componentProps: { me: this.userData }, showBackdrop: true });
    (await modal).onDidDismiss().then((val:any) => {
      this.dismissedPromotion = true;
    });
    (await modal).present();
  }

  openLinkPlayStore() {
    InAppBrowser.open({ url: 'https://play.google.com/store/account/subscriptions' });
  }

  getExpirationDateExists() {
    return this.purchaseServiceProvider.isPremium(this.userData);
  }

  getExpirationDate() {
    if (this.userData !== undefined) {
      let expiryTimeMillis: number = 0;
      

      if (this.userData[environment.products.club.id] && this.userData[environment.products.club.id].transaction && this.userData[environment.products.club.id].transaction.expiryTimeMillis !== undefined) {
        let timeMillis = this.userData[environment.products.club.id].transaction.expiryTimeMillis;
        // Handle MongoDB format {$numberLong: '...'}
        if (typeof timeMillis === 'object' && timeMillis.$numberLong) {
          timeMillis = parseInt(timeMillis.$numberLong);
        }
        expiryTimeMillis = timeMillis;
      }

      if (this.userData[environment.products.club_3_months.id] && this.userData[environment.products.club_3_months.id].transaction && this.userData[environment.products.club_3_months.id].transaction.expiryTimeMillis !== undefined && this.userData[environment.products.club_3_months.id].transaction.expiryTimeMillis > expiryTimeMillis) {
        let timeMillis = this.userData[environment.products.club_3_months.id].transaction.expiryTimeMillis;
        // Handle MongoDB format {$numberLong: '...'}
        if (typeof timeMillis === 'object' && timeMillis.$numberLong) {
          timeMillis = parseInt(timeMillis.$numberLong);
        }
        if (timeMillis > expiryTimeMillis) {
          expiryTimeMillis = timeMillis;
        }
      }

      if (this.userData[environment.products.club_6_months.id] && this.userData[environment.products.club_6_months.id].transaction && this.userData[environment.products.club_6_months.id].transaction.expiryTimeMillis !== undefined && this.userData[environment.products.club_6_months.id].transaction.expiryTimeMillis > expiryTimeMillis) {
        let timeMillis = this.userData[environment.products.club_6_months.id].transaction.expiryTimeMillis;
        // Handle MongoDB format {$numberLong: '...'}
        if (typeof timeMillis === 'object' && timeMillis.$numberLong) {
          timeMillis = parseInt(timeMillis.$numberLong);
        }
        if (timeMillis > expiryTimeMillis) {
          expiryTimeMillis = timeMillis;
        }
      }

      if (this.userData[environment.products.club_12_months.id] && this.userData[environment.products.club_12_months.id].transaction && this.userData[environment.products.club_12_months.id].transaction.expiryTimeMillis !== undefined && this.userData[environment.products.club_12_months.id].transaction.expiryTimeMillis > expiryTimeMillis) {
        let timeMillis = this.userData[environment.products.club_12_months.id].transaction.expiryTimeMillis;
        // Handle MongoDB format {$numberLong: '...'}
        if (typeof timeMillis === 'object' && timeMillis.$numberLong) {
          timeMillis = parseInt(timeMillis.$numberLong);
        }
        if (timeMillis > expiryTimeMillis) {
          expiryTimeMillis = timeMillis;
        }
      }

      if (this.userData[environment.products.club_30percent_off.id] && this.userData[environment.products.club_30percent_off.id].transaction && this.userData[environment.products.club_30percent_off.id].transaction.expiryTimeMillis > expiryTimeMillis) {
        let timeMillis = this.userData[environment.products.club_30percent_off.id].transaction.expiryTimeMillis;
        // Handle MongoDB format {$numberLong: '...'}
        if (typeof timeMillis === 'object' && timeMillis.$numberLong) {
          timeMillis = parseInt(timeMillis.$numberLong);
        }
        if (timeMillis > expiryTimeMillis) {
          expiryTimeMillis = timeMillis;
        }
      }
      
      if (expiryTimeMillis > 0) {
        let expiryDate = new Date(expiryTimeMillis);
        return expiryDate.toLocaleDateString(this.userData.language != null ? this.userData.language : 'en');
      } else {
        return false;
      }
    }
    return null; // Add this line to return a value if the condition is not met.
  }

  eachUnitWithDecimals(price: number, discountOffer: number) {
    //console.log("!!!Preço colocado: " + price + "\n!!!Disconto dado: "+ discountOffer);
    return (price * discountOffer / 100).toFixed(2);
  }

  isPriceLoaded(packageSelected: number, type: any): boolean {
    //return true;
    switch (type) {
      case 'coins':

        //console.log('!! Entrou no isPriceLoaded() ==> COINS !!');
        switch (packageSelected) {
          case 1:
            if (this.purchaseServiceProvider.oneCoinPriceSet) {
              return true;
            } else {
              return false;
            }

          case 10:
            if (this.purchaseServiceProvider.tenCoinPriceSet) {
              return true;
            } else {
              return false;
            }

          case 50:
            if (this.purchaseServiceProvider.fiftyCoinPriceSet) {
              return true;
            } else {
              return false;
            }

          case 100:
            if (this.purchaseServiceProvider.hundredCoinPriceSet) {
              return true;
            } else {
              return false;
            }

          default:
            console.log('!! Saiu do isPriceLoaded por default ==> COINS !!');
            return false;
        }

      case 'club':
        //console.log('!! Entrou no isPriceLoaded() ==> AVOCADO CLUB !!');
        switch (packageSelected) {
          case 1:
            if (this.purchaseServiceProvider.clubPriceSet || !!this.purchaseServiceProvider.clubPrice) {
              return true;
            } else {
              return false;
            }

          case 3:
            if (this.purchaseServiceProvider.club_3_monthsPriceSet || !!this.purchaseServiceProvider.club_3_monthsPrice) {
              return true;
            } else {
              return false;
            }

          case 6:
            if (this.purchaseServiceProvider.club_6_monthsPriceSet || !!this.purchaseServiceProvider.club_6_monthsPrice) {
              return true;
            } else {
              return false;
            }

          case 12:
            if (this.purchaseServiceProvider.club_12_monthsPriceSet || !!this.purchaseServiceProvider.club_12_monthsPrice) {
              return true;
            } else {
              return false;
            }

          default:
            //console.log('!! Saiu do isPriceLoaded por default ==> PREMIUM !!');
            return false;
        }
    }

    return true;
  }


  getPricesString(priceShown: number, type: string): string {
    switch (type) {
      case 'coins':
        switch (priceShown) {
          case 1:
            return this.purchaseServiceProvider.oneCoinPrice;

          case 10:
            return this.purchaseServiceProvider.tenCoinPrice;

          case 50:
            return this.purchaseServiceProvider.fiftyCoinPrice;

          case 100:
            return this.purchaseServiceProvider.hundredCoinPrice;

          default:
            console.log('!! Saiu por default ==> COINS !!');
            return '';
        }

      case 'club':
        //console.log('!! Entrou no getPricesString() => PREMIUM !!');
        switch (priceShown) {
          case 1:
            return this.purchaseServiceProvider.clubPrice;

          case 3:
            return this.purchaseServiceProvider.club_3_monthsPrice;

          case 6:
            return this.purchaseServiceProvider.club_6_monthsPrice;

          case 12:
            return this.purchaseServiceProvider.club_12_monthsPrice;

          default:
            //console.log('!! Saiu por default ==> PREMIUM !!');
            return '';
        }

      default:
        return '';

    }
    return '';
  }

  getCoinString(priceShown: number, type: string): string {
    switch (type) {
      case 'coins':
        switch (priceShown) {
          case 1:
            return '';

          case 10:
            return this.purchaseServiceProvider.tenCoinPrice;

          case 50:
            return this.purchaseServiceProvider.fiftyCoinPrice;

          case 100:
            return this.purchaseServiceProvider.hundredCoinPrice;

          default:
            console.log('!! Saiu por default ==> COINS !!');
            return '';
        }

      case 'club':
        //console.log('!! Entrou no getPricesString() => PREMIUM !!');
        switch (priceShown) {
          case 1:
            return this.purchaseServiceProvider.clubPrice;

          case 3:
            return this.purchaseServiceProvider.club_3_monthsPrice;

          case 6:
            return this.purchaseServiceProvider.club_6_monthsPrice;

          case 12:
            return this.purchaseServiceProvider.club_12_monthsPrice;

          default:
            //console.log('!! Saiu por default ==> PREMIUM !!');
            return '';
        }

      default:
        return '';

    }

  }

  getPricesNumberMicro(priceShown: number, type: string): number {
    switch (type) {
      case 'coins':
        switch (priceShown) {
          case 1:
            return this.purchaseServiceProvider.oneCoinPriceMicros;

          case 10:
            return this.purchaseServiceProvider.tenCoinPriceMicros;

          case 50:
            return this.purchaseServiceProvider.fiftyCoinPriceMicros;

          case 100:
            return this.purchaseServiceProvider.hundredCoinPriceMicros;

          default:
            return 0;
        }

      case 'club':
        switch (priceShown) {
          case 1:
            return this.purchaseServiceProvider.clubPriceMicros;

          case 3:
            return this.purchaseServiceProvider.club_3_monthsPriceMicros;

          case 6:
            return this.purchaseServiceProvider.club_6_monthsPriceMicros;

          case 12:
            return this.purchaseServiceProvider.club_12_monthsPriceMicros;

          default:
            return 0;
        }

      default:
        return 0;

    }

    return 0;
  }

  getProductCurrency() {
    if(this.userData != null){
      if(this.userData.config != null && this.userData.config[this.purchaseServiceProvider.productCurrency] != null){
        return this.userData.config[this.purchaseServiceProvider.productCurrency];
      }
    }
    
    
    return this.purchaseServiceProvider.productCurrency
  }


  switchButtonColours(button: string) {
    if (button == 'premium') {
      this.greyCoinsButton = false;
      this.greyPremiumButton = true;

    } else {
      this.greyCoinsButton = true;
      this.greyPremiumButton = false;
    }

  }

  dismiss() {
    // Just exit
    this.modalCtrl.dismiss();
  }


  unselectPackages() {
    this.selection = ["unselected", "unselected", "unselected", "unselected"];
  }


  optionClicked(option: number) {
    console.log('store.optionClicked');

    this.unselectPackages();

    this.selection[option] = "selected";
  }


  buy() {
    this.redirectToPurchase();
  }

  async showModalWaitForApproval() {
    let alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: this.translate.instant('waitForApproval'),
      buttons: [{
        text: this.translate.instant('cancel'),
        handler: () => {
          console.log('cancel clicked');
          return;
        }
      },
      {
        text: 'OK',

        handler: () => {
          console.log('OK clicked');
          this.redirectToPurchase();
          return;
        }
      }
      ]

    });

    (await alert).present();
  }

  getBuyButtonText(): string {
    if (this.selection[3] == "selected") {
      // Buy 12 months
      const price = this.getPricesString(12, 'club');
      return this.translate.instant('get12MonthsFor').replace('{0}', price);
    } else if (this.selection[1] == "selected") {
      // Buy 3 months
      const price = this.getPricesString(3, 'club');
      return this.translate.instant('get3MonthsFor').replace('{0}', price);
    } else if (this.selection[0] == "selected") {
      // Buy 1 month
      const price = this.getPricesString(1, 'club');
      return this.translate.instant('get1MonthFor').replace('{0}', price);
    } else {
      return this.translate.instant('buy');
    }
  }

  redirectToPurchase() {
    if (this.selection[0] == "selected") {
      // Buy 1 month
      this.purchaseServiceProvider.purchase(this.userData, this.purchaseServiceProvider.clubId, this.coinsDigits);
    } else if (this.selection[1] == "selected") {
      // Buy 3 months
      this.purchaseServiceProvider.purchase(this.userData, this.purchaseServiceProvider.club_3_monthsId, this.coinsDigits);
    } else if (this.selection[2] == "selected") {
      // Buy 6 months
      this.purchaseServiceProvider.purchase(this.userData, this.purchaseServiceProvider.club_6_monthsId, this.coinsDigits);
    } else if (this.selection[3] == "selected") {
      // Buy 12 months
      this.purchaseServiceProvider.purchase(this.userData, this.purchaseServiceProvider.club_12_monthsId, this.coinsDigits);
    } else {
      this.util.presentToast(this.toastCtrl, this.translate.instant('pleaseSelectPlan'), 5 * 1000);
    }
  }

  openAdvantageInfo() {

    this.showingAdvantage = !this.showingAdvantage;

  }

  dismissModal() {
    if (this.showingAdvantage) {
      this.showingAdvantage = false;
    }
  }


  formatNoDecimal(num: number) {
    return (Math.round(num * 100) / 100).toFixed(0);
  }

  format2Decimal(num: number) {
    return (Math.round(num * 100) / 100).toFixed(2);
  }

  formatMicro(priceMicro: number, units: number) {
    let num: number = priceMicro / (units * 1000 * 1000);
    return this.format2Decimal(num);
  }



}
